import { render } from "./surgeryIndex.vue?vue&type=template&id=3d9733c4&scoped=true"
import script from "./surgeryIndex.vue?vue&type=script&lang=js"
export * from "./surgeryIndex.vue?vue&type=script&lang=js"

import "./surgeryIndex.vue?vue&type=style&index=0&id=3d9733c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9733c4"]])

export default __exports__